import React, { useContext } from 'react';
import DecorativeBorder from 'chameleon/packages/blue-book-player/DecorativeBorder';
import PlayerMenu from 'chameleon/packages/blue-book-player/library/player-menu';
import AssignmentSessionWrapper from 'chameleon/packages/blue-book-player/HeaderContainer/AssignmentSessionWrapper';
import { BluebookContext } from '../state/BluebookContext';

const HeaderContainer = ({
  userData,
  learnosityApp,
  params,
  assignmentId,
  bluebookUiHighlightEnabled,
  isPreviewPlayer,
  isImpersonating,
  isDigitalExam,
}) => {
  const { state: playerState } = useContext(BluebookContext);
  const { title, assignmentPlayer, questions } = playerState;

  return (
    <div
      className="bluebook-player-header bg-bluebook-blue1"
      role="region"
      aria-label="Bluebook Controls"
      data-cy="header"
    >
      <div className="bb-desktop:h-[78px] bb-mobile:h-[44px] flex grow-0 shrink-0 text-gray-900 relative bb-mobile:justify-center">
        <div className="bb-mobile:hidden mt-[13px] flex flex-1 justify-start items-center">
          <h1 className="ml-[42px] text-gray-900 text-19 font-medium leading-[1.16] -tracking-[0.22px] m-0 truncate">
            {title}
          </h1>
        </div>
        <AssignmentSessionWrapper
          quizTitle={title}
          userData={userData}
          assignmentPlayer={assignmentPlayer}
          params={params}
          assignmentId={assignmentId}
          learnosityApp={learnosityApp}
        />
        <div className="flex bb-desktop:flex-1 bb-desktop:ml-auto bb-mobile:absolute bb-mobile:right-4 bb-mobile:top-[9px]">
          <PlayerMenu
            learnosityApp={learnosityApp}
            questions={questions}
            bluebookUiHighlightEnabled={bluebookUiHighlightEnabled}
            isPreviewPlayer={isPreviewPlayer}
            isImpersonating={isImpersonating}
            isDigitalExam={isDigitalExam}
          />
        </div>
      </div>
      <DecorativeBorder segmentNr={56} />
    </div>
  );
};
export default HeaderContainer;
